"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderCalculateFields = exports.timeSlot = exports.menuStyleFragment = exports.userInfoFragment = exports.orderDetailFragment = exports.fulfillmentCenterBasicFields = exports.orderAndMenuVenueFragment = exports.appConfigFragment = exports.pickupLocationFragment = exports.paymentMethodFragment = exports.itemFragment = exports.optionGroupFragment = exports.optionFragment = void 0;
const graphql_tag_1 = require("graphql-tag");
const venueConfigFragment = (0, graphql_tag_1.default) `
  fragment VenueConfigFragment on VenueConfig {
    defaultTipPercentage
    serviceFeeName
    tipPercentageOptions
    drinkUnitLimitPerPerson
    drinkUnitMinimum
    welcomeBackgroundUrl
    welcomeCopyBullets
    ticketInfoLabel
    disableCommentsOnMenuItems
  }
`;
exports.optionFragment = (0, graphql_tag_1.default) `
  fragment FullOption on Option {
    optionId
    name
    price
    imageUrl
    soldOut
    type
    options {
      hideImage
      customTitle
      customAlignment
      exclusive
    }
  }
`;
exports.optionGroupFragment = (0, graphql_tag_1.default) `
  fragment OptionGroupFragment on OptionGroup {
    id
    name
    widget
    required
    maximumAllowed
  }
`;
exports.itemFragment = (0, graphql_tag_1.default) `
  fragment FullItem on MenuItem {
    drinkId
    soldOut
    name
    price
    imageUrl
    description
    alcoholServings
    optionGroups {
      ...OptionGroupFragment
      options {
        ...FullOption
      }
    }
  }
  ${exports.optionGroupFragment}
  ${exports.optionFragment}
`;
exports.paymentMethodFragment = (0, graphql_tag_1.default) `
  fragment PaymentMethodFields on PaymentMethod {
    identifier
    isDefault
    type
    creditCardType
    imageUrl
    supportedProcessors
  }
`;
exports.pickupLocationFragment = (0, graphql_tag_1.default) `
  fragment PickupLocationFields on PickupLocation {
    id
    name
  }
`;
exports.appConfigFragment = (0, graphql_tag_1.default) `
  fragment FullConfig on AppConfig {
    facebookEnabled
    paymentMethods
    tosVersion
    verifyPhoneNumber
  }
`;
exports.orderAndMenuVenueFragment = (0, graphql_tag_1.default) `
  fragment OrderAndMenuVenueFields on Venue {
    id
    name
    imageUrl
    paymentProcessor
    requiredTipPercentage
    config {
      ...VenueConfigFragment
    }
    features
    timezone
    coordinate {
      lat
      lng
    }
  }
  ${venueConfigFragment}
`;
exports.fulfillmentCenterBasicFields = (0, graphql_tag_1.default) `
  fragment FulfillmentCenterBasicFields on FulfillmentCenter {
    id
    name
    pickup
    delivery
    convenienceFee
    allowImmediateOrders
    allowScheduledOrders
    isOpen
    deliveryText
    deliveryScreenInfoText
    minimumPreorderDate
    maximumPreorderDate
    minimumTipPercentage
    pickupLocations {
      id
      name
    }
    deliveryFields {
      label
      key
      regex
    }
    deliveryInfoText
  }
`;
exports.orderDetailFragment = (0, graphql_tag_1.default) `
  fragment OrderDetailFields on Order {
    id
    status
    createdAt
    orderNumber
    subtotal
    total
    scheduledTime
    ticketId
    taxes {
      name
      amount
    }
    serviceFees {
      name
      amount
    }
    deliveryLocation {
      key
      value
    }
    cart {
      item {
        name
        drinkId
        price
        imageUrl
        description
        soldOut
        alcoholServings
      }
      options {
        ...FullOption
      }
      quantity
      comments
    }
    tip {
      type
      amount
      percent
    }
    promoCode {
      amount
      brand {
        name
      }
    }
    deliveryLocation {
      key
      value
    }
    paymentMethod {
      ...PaymentMethodFields
    }
    fulfillmentCenter {
      id
      name
      convenienceFee
      pickup
      delivery
      pickupLocations {
        ...PickupLocationFields
      }
      deliveryFields {
        label
        key
      }
      deliveryInfoText
    }
    venue {
      id
      name
      imageUrl
      features
      requiredTipPercentage
      timezone
      config {
        ...VenueConfigFragment
      }
    }
  }
  ${exports.paymentMethodFragment}
  ${exports.optionFragment}
  ${exports.pickupLocationFragment}
  ${venueConfigFragment}
`;
exports.userInfoFragment = (0, graphql_tag_1.default) `
  fragment User on UserResponse {
    avatarUrl
    email
    firstName
    id
    joined
    lastName
    phone
    dateOfBirth
    gender
    firebaseAuthToken
    phoneVerified
    tosVersion
    provider
  }
`;
exports.menuStyleFragment = (0, graphql_tag_1.default) `
  fragment MenuStyleFragment on MenuStyle {
    backgroundImageUrl
    categoryTitleColor
    topBar {
      backgroundColor
      bottomBorder {
        color
        width
      }
      textColor
    }
    cartBar {
      backgroundColor
      topBorder {
        color
        width
      }
      textColor
    }
    venueTop {
      hideTitle
      photo
      hideShadow
    }
    categoryTiles {
      backgroundColor
    }
  }
`;
exports.timeSlot = (0, graphql_tag_1.default) `
  fragment TimeSlotFragment on TimeSlot {
    id
    name
    time
  }
`;
exports.orderCalculateFields = (0, graphql_tag_1.default) `
  fragment OrderCalculateFragment on OrderCalculateResponse {
    taxes {
      name
      amount
    }
    serviceFees {
      name
      amount
    }
    subtotal
    total
    brandSplitAmount
    promoAmount
  }
`;
//# sourceMappingURL=index.js.map